import { StyleProp, ViewStyle } from 'react-native';
import { ProductModelInstance } from 'src/store/_models/product';

export interface ProductOptionsMobileProps {
  product: ProductModelInstance;
  containerStyle?: StyleProp<ViewStyle>;
  avoidCounterAction?: boolean;
}

export enum ProductOptionsMobilePosition {
  LEFT = 'left',
  RIGHT = 'right',
}
